import { asyncAction } from 'lib/actions';

export const fetchAuctionsAction = asyncAction('auctions/FETCH');
